// extracted by mini-css-extract-plugin
module.exports = {"SingleItemCard":"SingleItemCard_SingleItemCard__MczC9"};